import styled from 'styled-components'

export const Item = styled.div`
  display: flex;
  align-items: center;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 8px 16px;
  padding-left: 12px;
  background-color: ${({ theme }) => theme.cor64}!important;
  margin-bottom: ${({ $isPreview }) => ($isPreview ? 0 : '8px')};
  box-shadow: ${({ $isDragging }) =>
    $isDragging
      ? '0 4px 12px rgba(0, 0, 0, 0.15)'
      : '0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)'};
  position: relative;
  color: ${({ theme }) => theme.cor9}!important;
  cursor: ${({ $isDragging, $draggable }) =>
    $isDragging ? 'grabbing' : $draggable ? 'pointer' : 'default'};
  opacity: ${({ $isDragging, $isPreview }) =>
    $isPreview ? 1 : $isDragging ? 0.5 : 1};
  transform: ${({ $transform }) => $transform || 'none'};
  transition: ${({ $transition }) =>
    $transition
      ? `${$transition}, box-shadow 0.15s ease, opacity 0.15s ease`
      : 'box-shadow 0.15s ease, opacity 0.15s ease'};
  height: 56px;
  min-height: 56px;
  max-height: 56px;
  pointer-events: ${({ $isPreview }) => ($isPreview ? 'none' : 'auto')};
`

export const Symbol = styled.div`
  font-size: 24px;
  font-weight: 700;
  min-width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.cor54};
`

export const DragHandle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: ${({ theme }) => theme.cor54};
  margin-right: 16px;
  cursor: grab;
  touch-action: none;
  &:active {
    cursor: grabbing;
  }
`

export const ItemContent = styled.div`
  flex: 1;
  min-width: 0;
`

export const IconButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ActionButton = styled.button`
  margin-left: auto;
  background: none;
  border: none;
  padding: 0;
  color: ${({ theme }) => theme.cor43};
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  cursor: pointer;
`

export const IconContainer = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
`

export const IconAction = styled.div`
  margin-left: auto;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
  display: flex;
  align-items: center;
`
